import SessionEventProto from "../session-event-proto";
import {EVENT_BUS_CHAT_UPDATE} from "../../model2/chat/chat/const";

export default class SessionEvent_ChatRoomUpdate extends SessionEventProto {

    constructor(sessionEvent:any) {
        super(sessionEvent)
    }

    process() {
        // do not process event for user who initialed update
        if (this.fromSID === gd.sessionId) {
            // console.log("same user -> ignore");
            return false;
        }

        if (!gd.session.chatsLoaded) {
            // well no chats in session so ignore I guess ?
            // gd.session.chats = new ChatCollection(this.data,{parse:true});
        } else {
            const chat = gd.session.chats.get(this.data.id);
            chat.name = this.data.name;
        }

        gd.bus.triggerEvent(EVENT_BUS_CHAT_UPDATE, this.data);
    }
};

